import React, { useEffect } from 'react'
import { FaAngleLeft } from 'react-icons/fa6'
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import visaCardLogo from '../../../../assets/img/logo/visa-card-logo.png';
import brandLogo from '../../../../assets/img/logo/cardplot_card_logo.png';
import masterCardBgImg from '../../../../assets/img/logo/card_bg-cardplot.png';


const FundSuccess = ({ userDetails }) => {
    const navigate = useNavigate();

    const cardDetails = {
        cardholderName: userDetails?.bank_account[0]?.account_name,
        nickname: "nickname",
        cardNumber: "6059 **** **** 9012",
        expiryDate: "04/27",
        fundingAmount: "$7,000",
        cardLogo: visaCardLogo,
        backgroundColor: "#2A0A7D"
    };

    useEffect(() => {
        toast.success("Card funded successfully!", {
            toastId: "fund-success-toast",
            position: "top-right",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            className: "custom-toast",
        });
    }, []);

    const handleGoBack = () => {
        navigate(`/user/cards/1`); 
        // navigate(`/user/cards/${cardId}`); 
    }

  return (
    <section className='create__card__page card__review__page'>
        <div className="d-flex align-items-center mt-3">
            <button onClick={handleGoBack} className="btn btn-sm" style={{ color: '#777' }}>
                <FaAngleLeft size={15} />
                <span className="ms-1 small mt-1">Back to Card Options</span>
            </button>
        </div>            

        <section className="create-card_section review__card__section">
            <div className="container py-5">

                <div className="card__review__details mt-5 pt-4">
                    <div className="card__details__display">
                        <div className="d-flex justify-content-center my-3">
                            <div className="card__details__preview" 
                                style={{
                                    backgroundColor: cardDetails.backgroundColor,
                                    backgroundImage: `url(${masterCardBgImg})`
                                }}>
                                    <div className="card__left__details">
                                        <h4>{cardDetails.nickname}</h4>

                                        <div className="">
                                            <h5>{cardDetails.cardholderName}</h5>
                                            <h6 className="mt-1">{cardDetails.cardNumber}</h6>
                                        </div>
                                    </div>
                                    <div className="card__right__details">
                                        <img src={brandLogo} alt="Card Logo" width="41.59px" height='35px' />
                                        <div className="">
                                            <span className='d-flex justify-content-end' style={{ fontSize: '7px' }}>debit</span>
                                            <img src={cardDetails.cardLogo} alt="Card Type" className='img-fluid' />
                                        </div>
                                    </div>
                            </div>
                        </div>
                        <div className="funding-amount mt-2">
                            <span>Funding Amount:</span>
                            <strong> {cardDetails.fundingAmount}</strong>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </section>
  )
}

export default FundSuccess